module.exports = __webpack_public_path__ + "media/images/phonenewpass-pic-9bbba0dc.svg";